export default __webpack_public_path__ + "static/safari-e4624b1e376a610356def2b7978fac12.png";